import { IconButton, Zoom } from '@material-ui/core'
import { EllipsisVertical, Mic, PaperclipIcon, Smile } from 'lucide-react'
import { useEffect } from 'react'
import EmojiOptions from '../EmojiOptions'
import { useStyles } from './style'

const FloatingActionMenu = ({
  loading,
  recording,
  showEmoji,
  setShowEmoji,
  handleAddEmoji,
  handleStartRecording,
  handleToggleFabMenu,
  fabMenuOpen,
  fabMenuRef
}) => {
  const classes = useStyles()
  const disableOption = loading || recording

  // const menuContainerRef = useRef(null)

  useEffect(() => {
    const handleClickOutside = event => {
      if (
        fabMenuOpen &&
        fabMenuRef.current &&
        !fabMenuRef.current.contains(event.target)
      ) {
        handleToggleFabMenu(false)
      }
    }

    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [fabMenuOpen, handleToggleFabMenu, fabMenuRef])

  return (
    <div className={classes.fabMenuWrapper} ref={fabMenuRef}>
      <IconButton
        aria-label="abrir menu"
        onClick={() => handleToggleFabMenu(!fabMenuOpen)}
        disabled={disableOption}
        className={classes.fabMenuButton}
      >
        <EllipsisVertical />
      </IconButton>

      <div className={classes.verticalContainer}>
        {/* Ação 1: Emoji */}
        <Zoom in={fabMenuOpen} timeout={300} unmountOnExit>
          <div>
            {/* 1. Usando o EmojiOptions como Wrapper conforme configurado anteriormente */}
            <EmojiOptions
              disabled={disableOption}
              showEmoji={showEmoji}
              setShowEmoji={setShowEmoji}
              handleAddEmoji={handleAddEmoji}
              position="floating"
            >
              <IconButton
                aria-label="emojiPicker"
                component="span"
                disabled={disableOption}
                className={`${classes.button} ${classes.emojiButton}`}
              >
                <Smile />
              </IconButton>
            </EmojiOptions>
          </div>
        </Zoom>

        {/* Ação 2: Arquivo */}
        <Zoom
          in={fabMenuOpen}
          timeout={300}
          style={{ transitionDelay: fabMenuOpen ? '75ms' : '0ms' }}
          unmountOnExit
        >
          <div>
            <label htmlFor="chat-upload-button">
              <IconButton
                className={`${classes.button} ${classes.fileButton}`}
                component="span"
                disabled={disableOption}
                aria-label="anexar arquivo"
                onClick={() => handleToggleFabMenu(false)}
              >
                <PaperclipIcon />
              </IconButton>
            </label>
          </div>
        </Zoom>

        {/* Ação 3: Microfone */}
        <Zoom
          in={fabMenuOpen}
          timeout={300}
          style={{ transitionDelay: fabMenuOpen ? '150ms' : '0ms' }}
          unmountOnExit
        >
          <IconButton
            className={`${classes.button} ${classes.micButton}`}
            onClick={() => {
              handleStartRecording()
              handleToggleFabMenu(false)
            }}
            disabled={disableOption}
            aria-label="gravar áudio"
          >
            <Mic />
          </IconButton>
        </Zoom>
      </div>
    </div>
  )
}

export default FloatingActionMenu
